import TRANSLATIONS from './json/cs_CZ_translations.json'

const TRANSLATIONS_CS_CZ = {
  'checkout_shipping.pOBoxWarningText': `${window.appConfig?.pOBoxWarningText}`,
  'shopping_cart_details.hoverToZoom': 'Přibližte kurzorem myši',
  'shopping_cart_details.tapToZoom': 'Přibližte klepnutím',
  'coupon_code.page_link': 'noOffersPagePresent',
  'order_summary.your_promos' : 'Vaše proma',
  'shopping_cart_details.editImprint': 'Upravit potisk',
  'shopping_cart_details.clickToZoom': 'Kliknutím zvětšíte zobrazení',
  'shopping_cart_details.ships_within_msg': 'Odešleme do [X] pracovních dní',
  'shopping_cart_details.item_total': 'Celkem položek:',
  'shopping_cart_details.each': '[X] za kus',
  'shopping_cart_details.see_more': 'Zobrazit Více',
  'shopping_cart_details.see_less': 'Zobrazit Méně',
  'order_confirmation.cartToOrderFailureMessage' : 'Vaši objednávku zanedlouho potvrdíme.',
  'checkout_payment.paymentErrorTitle': 'Chyba platby',
  'checkout_payment.paymentErrorMessage': 'Zkuste znovu zadat platební údaje. Pokud problém přetrvává, kontaktujte náš tým zákaznické podpory, která vám s radostí pomůže.',
  'checkout_payment.empty_string': '',
  'checkout_payment.credit_debit': 'Kreditní/Debetní karta',
  'checkout_payment.card_number': 'Číslo karty*',
  'checkout_payment.expiration_mm_yy': 'MM/RR*',
  'checkout_payment.cvv': 'CVV*',
  'checkout_payment.name_on_card': 'Jméno na kartě*',
  'checkout_payment.check_cc_try_again': 'Zkontrolujte číslo kreditní karty a zkuste to znovu.',
  'checkout_payment.check_date_try_again': 'Zkontrolujte datum a zkuste to znovu.',
  'checkout_payment.check_code_try_again': 'Zkontrolujte kód a zkuste to znovu.',
  'checkout_payment.enter_holder_name': 'Zadejte jméno na své kartě.',
  'checkout_payment.enter_cc_number': 'Zadejte číslo své karty.',
  'checkout_payment.enter_expiration_date': 'Zadejte datum expirace.',
  'checkout_payment.enter_cvv': 'Zadejte bezpečnostní kód.',
  'checkout_payment.paypal_pay_later': 'PayPal – Zaplatit později',
  'checkout_payment.continue_will_open_paypal_account_msg': 'Pokud budete pokračovat, budete přesměrováni na svůj účet PayPal.',
  'checkout_payment.continue_will_open_google_pay_account_msg': 'Pokračováním se přesměrujete na Google Pay.',
  'checkout_payment.paypal': 'PayPal',
  'checkout_payment.pay_by_invoice': 'Zaplatit fakturou',
  'checkout_payment.buy_now_pay_later_info_msg': 'Kupte nyní a zaplaťte později. Pošleme vám fakturu, až bude vaše objednávka na cestě.',
  'checkout_payment.learn_more': 'Zjistěte více',
  'checkout_payment.payment_due_late_fee_info_msg': 'Faktura bude splatná při jejím doručení. Zpoždění platby může způsobit poplatky navíc.',
  'shopping_cart_details.unit': 'jednotka',
  'shopping_cart_details.editModalSaving': `Ušetříte`,
  'shopping_cart_details.editModalMin_QtyWarning': `Je nám líto, ale takové množství nedosahuje povoleného minima. Pokud potřebujete menší objednávku, kontaktujte nás.`,
  'shopping_cart_details.editModalMax_QtyWarning': `Je nám líto, ale takové množství překračuje povolené maximum. Pokud potřebujete větší objednávku, kontaktujte nás.`,
  'product_details.price':'Cena',
  'product_details.edit_quantity':'Upravit množství',
  'myaccount_order_details.seeDetails': 'Zobrazit podrobnosti',
  'myaccount_order_details.viewOrderDetails': 'Zobrazit podrobnosti o objednávce',
  'myaccount_order_details.payMyInvoice': 'Zaplatit fakturu',
  'myaccount_order_details.buyItAgain': 'Koupit znovu',
  'myaccount_order_details.viewImprint': 'Zobrazit potisk',
  'myaccount_order_details.viewArtwork': 'Zobrazit grafiku',
  'myaccount_order_details.productDetails': 'Podrobnosti o výrobku',
  'myaccount_order_details.orders': 'objednávky',
  'my_account_order_details.shipping_and_billing_addresses': 'Doručovací a fakturační adresy',
  'my_account_order_details.log_in_to_view' : 'Zobrazí se po přihlášení',
  'error.use_of_old_password': 'Heslo se musí lišit od pěti předchozích hesel.',
  'order_confirmation.postCheckout_signIn':`Přihlaste se a získejte další výhody`,
  'order_confirmation.postCheckout_accountCreation':'Přihlaste se a získejte další výhody',
  'order_confirmation.postCheckout_trackOrder':'Sledujte svou objednávku jednoduše',
  'order_confirmation.would_you_like_to':'Přihlaste se k odběru nabídek od Pens.com e-mailem nebo telefonem a získejte zvláštní slevy a vzorky zdarma!',
  'order_confirmation.sign_up.contact_agreement1':'Ano',
  'order_confirmation.sign_up.contact_agreement2':', miluju akční nabídky!',
  'order_confirmation.sign_up.contact_disagreement1':'Ne',
  'order_confirmation.sign_up.contact_disagreement2':', díky',
  'create_account.title':'Založte si účet',
  'order_confirmation.sign_in.title':'Přihlaste se ke svému účtu',
  'order_confirmation.my_acc.title':'Můj účet',
  'order_confirmation.addPassword':'Stačí přidat heslo:',
  'order_confirmation.accountCreated':'Účet vytvořen',
  'myaccount_address_list.shippingAddresses': 'Doručovací adresa',
  'myaccount_address_list.billingAddresses': 'Fakturační adresa',
  'myaccount_address_list.defaultAddress': 'Výchozí adresa',
  'myaccount_address_list.setDefault': 'Nastavit výchozí',
  'myaccount_delete_address.delete_confirmation': 'Potvrzení odstranění',
  'myaccount_delete_address.confirmation_message': 'Skutečně si přejete odstranit tuto adresu?',
  'myaccount_delete_address.delete_address': 'Odstranit adresu',
  'myaccount_delete_address.delete': 'Odstranit',
  'myaccount_error_new_password.complexity':"Nové heslo musí obsahovat: číslici, zvláštní znak [!#$%&'*+-/=?^_`{|}~.@], velká a malá písmena.",
  'myaccount_error_confirm_password.complexity':"Potvrzené heslo musí obsahovat: číslici, zvláštní znak [!#$%&'*+-/=?^_`{|}~.@], velká a malá písmena.",
  'myaccount_error_new_password.common_password':'Nové heslo nesmí být shodné s vaší e-mailovou adresou.',
  'myaccount_error_confirm_password.common_password':'Potvrzené heslo nesmí být shodné s vaší e-mailovou adresou.',
  'myaccount.change_personal_information.change_password_info' : 'Na všech aktivních zařízeních dojde k odhlášení.',
  'validation.password_validation_heading' : 'Heslo musí obsahovat:',
  'validation.password_validation_uppercase' : 'Velké písmeno',
  'validation.password_validation_lowercase' : 'Malé písmeno',
  'validation.password_validation_symbol' : 'Zvláštní znak',
  'validation.password_validation_number' : 'Číslici',
  'validation.password_validation_length' : 'Nejméně 8 znaků',
  'validation.password_validation_match' : 'Hesla se musí shodovat',
  'validation.password_min_characters': 'Heslo musí mít nejméně 8 znaků.',
  'myaccount_password_settings.heading' : 'Nastavení hesla',
  'myaccount_password_settings.newPassword' : 'Nové heslo',
  'myaccount_password_settings.confirmPassword' : 'Potvrdit heslo',
  'myaccount_password_settings.updatePassword' : 'Aktualizovat heslo',
  'myaccount_password_settings.createPassword' : 'Vytvořit heslo',
  'myaccount_password_settings.use_of_old_password': 'Heslo se musí lišit od pěti předchozích hesel.',
  'order_details.payment_mode_apple_pay' : 'Apple Pay',
  'order_details.payment_mode_google_pay' : 'Google Pay',
  'order_details.payment_mode_ideal' : 'iDEAL',
  'order_details.payment_mode_bancontact' : 'Bancontact',
  'order_details.payment_mode_klarna' : 'Klarna',
  'shopping_bag.expired_discount_coupon':'Zadaný promokód už neplatí. Zadejte jiný promokód.',
  'shopping_bag.invalid_discount_coupon':'Zadaný promokód neplatí. Zadejte jiný promokód.',
  'order_summary.oops_error': 'Ale ne! Vypadá to, že se u nás něco pokazilo. Zkuste to znovu.',
  'order_summary.one_promo_at_a_time': 'Najednou můžete použít vždy jen jeden promokód.',
  'order_summary.code_applied': 'Kód byl uplatněn',
  'order_summary.change_promo': 'Zadejte promokód',
  'order_summary.your_promo_code': 'Vaše promokódy',
  'order_summary.no_items_eligible': 'Žádné položky ve vašem košíku nejsou vhodné pro použití tohoto promokódu.',
  'order_details.production_time_begin_msg': '*Doba výroby začíná potvrzením objednávky a schválením veškeré grafiky',
  'order_details.reorder_tat': 'Opětovnou objednávku odešleme za X pracovní dny*',
  'dashboard.edit' : 'Upravit',
  'dashboard.greeting':'Dobrý den,',
  'myaccount_personal_info.save_changes' : 'Uložit změny',
  'myaccount_personal_info.cancel' : 'Storno',
  'myaccount_personal_info.name_title' : 'Jméno',
  'myaccount_personal_info.password_title' : 'Heslo',
  'myaccount_personal_info.add_name' : 'Přidat jméno',
  'myaccount_personal_info.edit_name' : 'Upravit jméno',
  'myaccount_personal_info.name_updated' : 'Jméno upraveno.',
  'myaccount.something_went_wrong': 'Došlo k chybě. Zkuste to znovu.',
  'checkout.reorder.buy_it_again':'Koupit znovu',
  'checkout.reorder.purchased':'Zakoupeno',
  'checkout.reorder.last_qty':'Množství objednané naposledy',
  'checkout.reorder.ships_within_msg':'Odešleme do [X] pracovních dní',
  'checkout.reorder.add_to_cart': 'Přidat do košíku',
  'shopping_cart_details.add_accessory': 'Přidejte doplněk',
  'oos.item_out_of_stock': 'Tato položka je momentálně vyprodaná.',
  'oos.view_similar': 'Zobrazit podobné produkty',
  'oos.similar_products': 'Podobné výrobky',
  'oos.remove_out_of_stock_items': 'Je nám líto, musíte z košíku odstranit vyprodané položky.',
  'oos.one_or_more_items_removed_from_cart': 'Jedna nebo více velikostí není skladem a byla odstraněna z položky.',
  'oos.go_back_to_review': 'Vraťte se do košíku a zkontrolujte nákup',
  'oos.go_back_to_remove': 'Vraťte se do košíku a odstraňte položku',
  'oos.out_of_stock': 'Vyprodáno',
  'shopping_cart_details.add_amount': 'Pro aktivování nabídky přidejte [X]',
  'import_charge_title':'Cla',
  'import_charge_description':'Stávající cla ovlivnila ceny našich produktů. Snažíme se ale snížit dopady na růst cen pro naše zákazníky.',
  'gdpr.heading' : 'Účet byl vytvořen, vítáme vás.',
  'gdpr.subheading' : 'Váš účet byl vytvořen za využití vaší e-mailové adresy:',
  'gdpr.promotion': 'Přihlaste se k odběru emailových nabídek od Pens.com a získejte speciální slevy a vzorky zdarma!',
  'gdpr.yesDeal' : 'Ano, tahle nabídka se mi líbí',
  'gdpr.noDeal' : 'Ne, díky',
  'gdpr.button' : 'Pokračovat',
  'new_activation.head' : 'Koukněte do své e-mailové schránky.',
  'new_activation.sub_head' : 'Dobrý den,',
  'new_activation.main_body1' : 'děkujeme, že jste se přihlásili do Pens.com.',
  'new_activation.main_body2' : 'Odkaz k aktivaci zašleme na Vaši e-mailovou adresu.',
  'new_activation.main_body3' : 'Můžete se přihlásit až ve chvíli, kdy bude Váš účet aktivní. Prosím klikněte na odkaz pro aktivaci Vašeho účtu.',
  'myaccount_personal_info.password_not_set' : 'Pro tento účet nebylo heslo nastaveno.',
  'myaccount_personal_info.click_here' : 'Klikněte sem',
  'myaccount_personal_info.to_reset_password' : 'a vytvořte nové heslo. ',
  'myaccount_personal_info.note' : 'Poznámka: Tímto krokem se odhlásíte ze všech aktivních výběrů.',
  'moq.lineItem_warning': 'Objednávané množství nedosahuje minimálního množství pro tuto položku.',
  'moq.edit_qantity_link_text': 'Objednejte jiné množství.',
  'moq.cart_level_warning': 'Upravte množství položky v objednávce, abyste mohli p?ejít k pokladn?.',
  'moq.go_back_to_cart': 'K výběru množství nové objednávky se vraťte do nákupního košíku',
  ...TRANSLATIONS
};
export default TRANSLATIONS_CS_CZ;